import { useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import { BLOG_POSTS } from "./data";

const BlogPage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main>
        <section className="relative pt-32 pb-20 bg-[#0D0D0D] overflow-hidden">
          <div className="absolute inset-0 opacity-15">
            <img
              src="/images/menu-icin-cephe-44a1019c.png"
              alt="Blog"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
          <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
            <div className="flex items-center gap-2 mb-6 anim-down d0">
              <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
                Ana Sayfa
              </Link>
              <i className="ri-arrow-right-s-line text-white/30 text-xs" />
              <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">Blog</span>
            </div>
            <div className="flex items-center gap-3 mb-5 anim-left d1">
              <div className="w-8 h-[2px] bg-[#E6A800]" />
              <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Yazılar</span>
            </div>
            <h1 className="font-head font-black uppercase text-white text-[clamp(44px,7vw,86px)] leading-[0.9] anim-up d2">
              Reklam ve
              <br />
              <span className="text-[#E6A800]">Dekorasyon Blogu</span>
            </h1>
            <p className="text-white/55 text-sm leading-relaxed max-w-xl mt-6 anim-up d3">
              Tabela seçimi, dış cephe trendleri ve LED teknolojileri hakkında markanıza değer katacak
              güncel içerikler.
            </p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_POSTS.map((post, i) => (
              <article
                key={post.slug}
                className="group border border-[#EDEDED] bg-white hover:shadow-[0_22px_55px_rgba(0,0,0,0.08)] transition-all anim-up"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <Link to={`/blog/${post.slug}`} className="block overflow-hidden">
                  <img
                    src={post.coverImg}
                    alt={post.title}
                    className="w-full h-60 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </Link>
                <div className="p-6">
                  <p className="text-[#9E9E9E] text-sm mb-3">
                    {post.date} · {post.readTime} okuma
                  </p>
                  <h2 className="text-[#0D0D0D] font-head font-800 text-2xl leading-tight mb-3">
                    {post.title}
                  </h2>
                  <p className="text-[#555] text-base leading-relaxed mb-5">{post.excerpt}</p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="inline-flex items-center gap-2 text-[#E6A800] font-head font-700 uppercase tracking-wide"
                  >
                    Devamını Oku
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default BlogPage;
